import NormalButton from "../../components/buttons/normal-button";
import AmpleHireModalTrigger from "../../components/modals/ample-hire-modal-trigger";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setDeleteLocationId } from "../../redux/slices/location-slice";
import getUniqueId from "../../utils/getUniqueId";

const LocationTableRow = ({ location, index }) => {
  const { id, countryName, stateName, cityName, address } = location;
  // const [counter, setCounter] = useState(0);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <tr>
      <td>{index + 1}</td>
      <td>{countryName}</td>
      <td>{stateName}</td>
      <td>{cityName}</td>
      <td>
        {address.map((val, index) => {
          return (
            <p key={getUniqueId()}>
              {index + 1}. {val}
            </p>
          );
        })}
      </td>

      <td>
        <div className="flex-start manage-masters-table-row">
          <NormalButton
            buttonTagCssClasses={"btn-clear"}
            buttonText={"Edit"}
            onClick={() => {
              navigate(`edit-location/${id}`, {
                state: {
                  countryName,
                  stateName,
                  cityName,
                  address,
                },
              });
            }}
          />
          <AmpleHireModalTrigger modalId={"confirmDeleteModal"}>
            <NormalButton
              buttonTagCssClasses={"btn-clear btn-submit"}
              buttonText={"Delete"}
              onClick={() => {
                dispatch(setDeleteLocationId(id));
              }}
            />
          </AmpleHireModalTrigger>
        </div>
      </td>
    </tr>
  );
};

export default LocationTableRow;
